export default "__VITE_ASSET__ad08ec00__"